import { styled } from '@mui/material/styles';
import { Typography } from '@sunwisesoftware/sunwise-ui';

export default styled(Typography)(() => ({
    color: 'rgba(255, 255, 255, 0.50)',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: '500',
    letterSpacing: '0.4px',
    margin: '0 16px',
    textTransform: 'uppercase',
}));
